import styles from './blue.module.css';
import DOMPurify from 'dompurify';
const Blue = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_577_1242)">
          <path
            d="M38.2426 32.0795L49.824 43.6608L34.7413 58.7435H29.408V40.9142L17.7706 52.5515L13.9973 48.7808L29.408 33.3728V30.7862L13.9973 15.3728L17.7706 11.6022L29.408 23.2395V5.41016H34.7413L49.824 20.4955L38.2426 32.0768V32.0795ZM34.7413 36.1168V51.2022L42.2826 43.6608L34.7413 36.1168ZM34.7413 28.0368L42.2826 20.4955L34.7413 12.9542V28.0395V28.0368Z"
            fill="#4D88FF"
          />
          <g opacity="0.4">
            <path
              d="M49.1716 34.8284C49.9218 35.5786 50.9392 36 52 36C53.0609 36 54.0783 35.5786 54.8285 34.8284C55.5786 34.0783 56 33.0609 56 32C56 30.9391 55.5786 29.9217 54.8285 29.1716C54.0783 28.4214 53.0609 28 52 28C50.9392 28 49.9218 28.4214 49.1716 29.1716C48.4215 29.9217 48 30.9391 48 32C48 33.0609 48.4215 34.0783 49.1716 34.8284Z"
              fill="#4D88FF"
            />
            <path
              d="M14.5049 34.8284C15.2551 35.5786 16.2725 36 17.3334 36C18.3942 36 19.4117 35.5786 20.1618 34.8284C20.9119 34.0783 21.3334 33.0609 21.3334 32C21.3334 30.9391 20.9119 29.9217 20.1618 29.1716C19.4117 28.4214 18.3942 28 17.3334 28C16.2725 28 15.2551 28.4214 14.5049 29.1716C13.7548 29.9217 13.3334 30.9391 13.3334 32C13.3334 33.0609 13.7548 34.0783 14.5049 34.8284Z"
              fill="#4D88FF"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_577_1242">
            <rect width="64" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text20']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text21']),
          }}
        ></h5>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text22']),
          }}
        ></h6>
      </div>

      <div className={styles.blueMainIconBox}>
        <div className={styles.blueMainIcon}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_724_56)">
              <path
                d="M15.5333 14.9447C16.3639 14.1091 16.9295 13.0445 17.1586 11.8855C17.3878 10.7266 17.2701 9.52528 16.8206 8.43357C16.371 7.34187 15.6097 6.40878 14.633 5.7523C13.6563 5.09582 12.508 4.74542 11.3333 4.74542C10.1587 4.74542 9.01036 5.09582 8.03365 5.7523C7.05693 6.40878 6.29567 7.34187 5.84611 8.43357C5.39655 9.52528 5.2789 10.7266 5.50802 11.8855C5.73715 13.0445 6.30276 14.1091 7.13334 14.9447L11.3333 19.1697L15.5333 14.9447ZM11.3333 23.9972L4.73212 17.3602C3.42727 16.047 2.53879 14.374 2.17902 12.5529C1.81925 10.7317 2.00433 8.84418 2.71088 7.12885C3.41743 5.41352 4.61371 3.94745 6.14847 2.91598C7.68323 1.88452 9.48756 1.33398 11.3333 1.33398C13.1791 1.33398 14.9834 1.88452 16.5182 2.91598C18.053 3.94745 19.2492 5.41352 19.9558 7.12885C20.6623 8.84418 20.8474 10.7317 20.4876 12.5529C20.1279 14.374 19.2394 16.047 17.9345 17.3602L11.3333 24.0007V23.9972ZM11.3333 13.2803C10.6582 13.2803 10.0108 13.0105 9.53343 12.5303C9.05606 12.0501 8.78788 11.3988 8.78788 10.7197C8.78788 10.0406 9.05606 9.3893 9.53343 8.9091C10.0108 8.42889 10.6582 8.15912 11.3333 8.15912C12.0084 8.15912 12.6559 8.42889 13.1332 8.9091C13.6106 9.3893 13.8788 10.0406 13.8788 10.7197C13.8788 11.3988 13.6106 12.0501 13.1332 12.5303C12.6559 13.0105 12.0084 13.2803 11.3333 13.2803Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.8946 26.7612L24.6667 30.6653V30.6673L28.4388 26.7612C29.1845 25.9887 29.6922 25.0046 29.8977 23.9333C30.1033 22.8621 29.9976 21.7517 29.5938 20.7427C29.1901 19.7337 28.5065 18.8713 27.6295 18.2646C26.7525 17.6578 25.7214 17.334 24.6667 17.334C23.612 17.334 22.5809 17.6578 21.7039 18.2646C20.8269 18.8713 20.1433 19.7337 19.7396 20.7427C19.3359 21.7517 19.2301 22.8621 19.4357 23.9333C19.6413 25.0046 20.149 25.9887 20.8946 26.7612ZM24.6667 24.3617C24.2809 24.3617 23.911 24.203 23.6382 23.9205C23.3654 23.638 23.2122 23.2549 23.2122 22.8555C23.2122 22.456 23.3654 22.0729 23.6382 21.7904C23.911 21.5079 24.2809 21.3492 24.6667 21.3492C25.0525 21.3492 25.4224 21.5079 25.6952 21.7904C25.968 22.0729 26.1213 22.456 26.1213 22.8555C26.1213 23.2549 25.968 23.638 25.6952 23.9205C25.4224 24.203 25.0525 24.3617 24.6667 24.3617Z"
                fill="#5E6266"
              />
            </g>
            <defs>
              <clipPath id="clip0_724_56">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text23']),
            }}
          ></div>
        </div>

        <div className={styles.blueMainIcon}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_724_75)">
              <path
                d="M16 1.33398L26.956 3.76865C27.5653 3.90465 28 4.44465 28 5.06998V18.386C28 21.0607 26.6627 23.5593 24.4373 25.042L16 30.6673L7.56267 25.042C5.336 23.558 4 21.0607 4 18.3873V5.06998C4 4.44465 4.43467 3.90465 5.044 3.76865L16 1.33398ZM16 4.06598L6.66667 6.13932V18.386C6.66667 20.1687 7.55733 21.834 9.04133 22.8233L16 27.4633L22.9587 22.8233C24.4427 21.834 25.3333 20.17 25.3333 18.3873V6.13932L16 4.06598Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.3334 11.259L14.8951 20.0007L9.33337 13.8789C10.4895 12.8472 12.2611 12.94 13.3031 14.0869L14.9575 15.9078L19.3602 11.3469C20.4361 10.2323 22.2092 10.1931 23.3334 11.259Z"
                fill="#5E6266"
              />
            </g>
            <defs>
              <clipPath id="clip0_724_75">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text24']),
            }}
          ></div>
        </div>

        <div className={styles.blueMainIcon}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_724_62)">
              <path
                d="M9.26669 1.33398L11.152 3.23836L7.77069 6.65385H25.3334V9.34745H7.77069L11.152 12.7629L9.26669 14.6673L2.66669 8.00065L9.26669 1.33398Z"
                fill="white"
              />
              <path
                d="M29.3334 24.0007L22.7334 17.334L20.848 19.2384L24.2294 22.6539H6.66669V25.3475L24.2294 25.3461L20.848 28.7629L22.7334 30.6673L29.3334 24.0007Z"
                fill="white"
              />
              <path
                d="M16.5 15.0297H20L15.5 21.3327V16.969H12L16.5 10.666V15.0297Z"
                fill="#5E6266"
              />
            </g>
            <defs>
              <clipPath id="clip0_724_62">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text25']),
            }}
          ></div>
        </div>

        <div className={styles.blueMainIcon}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_724_69)">
              <path
                d="M14.5866 14.0803C14.3902 13.8972 14.2325 13.6764 14.1232 13.431C14.0139 13.1857 13.9551 12.9209 13.9504 12.6523C13.9457 12.3838 13.9951 12.117 14.0957 11.868C14.1962 11.619 14.346 11.3928 14.5359 11.2028C14.7258 11.0129 14.952 10.8632 15.2011 10.7626C15.4501 10.662 15.7168 10.6126 15.9854 10.6174C16.2539 10.6221 16.5188 10.6809 16.7641 10.7902C17.0094 10.8995 17.2302 11.0571 17.4133 11.2536C17.7666 11.6327 17.9589 12.1342 17.9498 12.6523C17.9406 13.1705 17.7307 13.6648 17.3643 14.0313C16.9979 14.3977 16.5035 14.6076 15.9854 14.6167C15.4672 14.6259 14.9658 14.4336 14.5866 14.0803ZM7.04132 3.71094L8.92798 5.5976C7.05287 7.47294 5.99945 10.0163 5.99945 12.6683C5.99945 15.3202 7.05287 17.8636 8.92798 19.7389L7.04132 21.6256C5.86491 20.4494 4.93173 19.0529 4.29506 17.516C3.65838 15.9791 3.33069 14.3318 3.33069 12.6683C3.33069 11.0047 3.65838 9.35743 4.29506 7.82052C4.93173 6.28361 5.86491 4.88717 7.04132 3.71094ZM24.956 3.71094C26.1324 4.88717 27.0656 6.28361 27.7022 7.82052C28.3389 9.35743 28.6666 11.0047 28.6666 12.6683C28.6666 14.3318 28.3389 15.9791 27.7022 17.516C27.0656 19.0529 26.1324 20.4494 24.956 21.6256L23.0693 19.7389C24.9444 17.8636 25.9978 15.3202 25.9978 12.6683C25.9978 10.0163 24.9444 7.47294 23.0693 5.5976L24.956 3.71094ZM10.8133 7.4816L12.6987 9.36694C12.2653 9.80028 11.9215 10.3148 11.6869 10.881C11.4524 11.4472 11.3316 12.0541 11.3316 12.6669C11.3316 13.2798 11.4524 13.8867 11.6869 14.4529C11.9215 15.0191 12.2653 15.5336 12.6987 15.9669L10.8133 17.8523C9.43812 16.477 8.66555 14.6118 8.66555 12.6669C8.66555 10.7221 9.43812 8.85686 10.8133 7.4816ZM21.184 7.4816C22.5592 8.85686 23.3318 10.7221 23.3318 12.6669C23.3318 14.6118 22.5592 16.477 21.184 17.8523L19.2987 15.9669C19.732 15.5336 20.0758 15.0191 20.3104 14.4529C20.5449 13.8867 20.6657 13.2798 20.6657 12.6669C20.6657 12.0541 20.5449 11.4472 20.3104 10.881C20.0758 10.3148 19.732 9.80028 19.2987 9.36694L21.184 7.4816Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16 18.666L21.3333 29.3327H10.6666L16 18.666Z"
                fill="#5E6266"
              />
            </g>
            <defs>
              <clipPath id="clip0_724_69">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text26']),
            }}
          ></div>
        </div>

        <img className={styles.img} src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-bluetooth.png"></img>
        <svg
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.circle}
          fill="none"
        >
          <circle cx="50%" cy="50%" r="50%" />
        </svg>

        <div className={styles.rippleBox}>
          <div
            className={styles.ripple}
            style={{
              '--effect-time-ripple-delay': '0s',
            }}
          ></div>
          <div
            className={styles.ripple}
            style={{
              '--effect-time-ripple-delay': '2s',
            }}
          ></div>
          <div
            className={styles.ripple}
            style={{
              '--effect-time-ripple-delay': '5s',
            }}
          ></div>
          <div
            className={styles.ripple}
            style={{
              '--effect-time-ripple-delay': '6s',
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Blue;
